import { createSelector } from 'reselect';

export const getComponentState = state => state.adminUsers;

export const getUsers = createSelector(
    getComponentState,
    (state) => state.users
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getSaving = createSelector(
    getComponentState,
    (state) => state.saving
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getFields = createSelector(
    getComponentState,
    (state) => state.fields
);
export const getIsDeleting = createSelector(
    getComponentState,
    (state) => state.isDeleting
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getPermissions = createSelector(
    getComponentState,
    (state) => state.permissions
);